import { PanelCloseCustomData } from '../../datapoints';
import { differenceInMilliseconds, now } from 'owa-datetime';
import getStore from '../../store/store';

export default function getPanelCloseCustomData(): PanelCloseCustomData {
    return {
        sessionDuration: getSessionDuration(),
    };
}

function getSessionDuration() {
    const panelOpenTime = getStore().panelOpenTime;
    return panelOpenTime ? differenceInMilliseconds(now(), panelOpenTime) : null;
}
